import React from 'react'
import { Modal, Button, Icon } from 'antd'

/**
 * Premium modal for notifying user about missing voice selections
 * Uses styles defined in Voiceover.scss
 */
const VoiceSelectionRequiredModal = ({
  visible,
  onCancel,
  missingNarrator,
  charactersWithoutVoice
}) => {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={500}
      centered
      className="voice-required-modal"
      destroyOnClose
    >
      <div className="voice-required-modal__content">
        <div className="voice-required-modal__header">
          <div className="voice-required-modal__icon-wrapper">
            <Icon type="warning" />
          </div>
          <h2 className="voice-required-modal__title">
            Voice Selection Required
          </h2>
        </div>

        <div className="voice-required-modal__body">
          {missingNarrator && (
            <div className="voice-required-modal__section">
              <h3 className="voice-required-modal__section-title">
                Narrator Voice Missing
              </h3>
              <p className="voice-required-modal__text">
                Please select a voice for the narrator to proceed.
              </p>
            </div>
          )}

          {charactersWithoutVoice && charactersWithoutVoice.length > 0 && (
            <div className="voice-required-modal__section">
              <h3 className="voice-required-modal__section-title">
                Character Voices Missing
              </h3>
              <p className="voice-required-modal__text">
                The following characters need a voice assigned:
              </p>
              <ul className="voice-required-modal__list">
                {charactersWithoutVoice.map((name, index) => (
                  <li key={index} className="voice-required-modal__list-item">
                    {typeof name === 'object' ? name.name : name}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className="voice-required-modal__actions">
          <Button
            type="primary"
            onClick={onCancel}
            className="voice-required-modal__btn"
          >
            Got it
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default VoiceSelectionRequiredModal
